module.exports = __webpack_public_path__ + "static/img/5825_phase_function_Paper_PointsHejduk_Prediction.6685d4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5825_phase_function_Paper_PointsHejduk_Prediction.png
// module id = BRYv
// module chunks = 0